import { render } from "./tourism.vue?vue&type=template&id=7f36e550&scoped=true"
import script from "./tourism.vue?vue&type=script&lang=js"
export * from "./tourism.vue?vue&type=script&lang=js"

import "./tourism.vue?vue&type=style&index=0&id=7f36e550&lang=scss&scoped=true"
import "./tourism.vue?vue&type=style&index=1&id=7f36e550&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f36e550"]])

export default __exports__